<template>
  <el-tag size="medium" :type="cssClass" v-if="!!priorityName">
    <i class="fas fa-bolt"></i>
    {{ priorityName }}
  </el-tag>
</template>

<script>
  export default {
    name: "doc-priority-tag",
    props: ["priorityName"],

    data() {
      return {
        cssClass: null
      };
    },

    watch: {
      priorityName() {
        this.initComponent();
      }
    },

    created() {
      this.initComponent();
    },

    methods: {
      initComponent() {
        this.cssClass = this.initCssClass();
      },

      initCssClass() {
        switch (this.priorityName) {
          case "Khẩn":
          case "Hỏa tốc":
            return "danger";
          default:
            return "";
        }
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/common/doc-priority-tag.vue